import * as React from 'react';
import PropTypes from 'prop-types';
import {Button, Form, FormField,  Input} from "semantic-ui-react";
import {Subbar, Title, PageHeader} from "ah-tools";
import {FormLabel} from "../extensions";
import EuroIcon from 'material-ui/svg-icons/action/euro-symbol';
import TimeIcon from 'material-ui/svg-icons/av/av-timer';
import {translate} from "react-i18next";
import {processData} from "ah-lib";
import isNum from 'lodash/isNumber';

class WorkTime extends React.Component {
	static propTypes = {
		title: PropTypes.string,
		open: PropTypes.bool,
		kfz2service: PropTypes.object,
		onShowDetail: PropTypes.func,
		onDelete: PropTypes.func,
		onSave: PropTypes.func,
		isSaving: PropTypes.func,
		extendedData: PropTypes.object,
		onSaveSuccess: PropTypes.func,
		shouldClear: PropTypes.bool,
		priceRequired: PropTypes.bool,
		readOnlyTime: PropTypes.bool
	};
	static defaultProps = {
		open: true,
		onSave: () => alert('fufu onSave() missing'),
		isSaving: () => false,
		extendedData: {},
		shouldClear: undefined,
		priceRequired: false,
		readOnlyTime: false
	};
	state = {
		data: {
			kfz_id: null,
			service_id: null,
			price: '',
			hours_of_work: ''
		}
	};
	
	setData = (index, value) => this.setState(state => ({
		...state,
		data: {
			...state.data,
			[index]: value
		}
	}));
	
	_handleData = (data) => data && this.setState(state => ({
		...state,
		data: {
			...state.data,
			...processData(data)(d => {
				if (this.props.shouldClear === undefined) {
					d.price = d.price !== undefined ? d.price : '';
					d.hours_of_work = d.hours_of_work !== undefined ? d.hours_of_work : '';
				}
			})
		}
	}));
	
	_handleClear = () => this.setState(state => ({
		...state,
		data: {
			...state.data,
			price: '',
			hours_of_work: ''
		}
	}));
	
	isNew = () => !this.props.kfz2service.hours_of_work;
	
	componentDidMount() {
		this._handleData(this.props.kfz2service);
		this.props.shouldClear && this._handleClear();
	}
	componentWillReceiveProps({kfz2service, shouldClear}) {
		this._handleData(kfz2service);
		shouldClear && this._handleClear();
	}
	
	onSave = () => {
		const data = this.state.data;
		const {priceRequired, extendedData, onSave, onSaveSuccess} = this.props;
		data.price = priceRequired ? data.price : String(data.price).trim() === '' ? null : data.price;
		onSave({...data, ...extendedData}, onSaveSuccess);
	};
	
	render() {
		const {t, i18n, tReady, title, open, onShowDetail, onDelete, onSave, kfz2service, readOnlyTime, isSaving, extendedData, onSaveSuccess, shouldClear, priceRequired, ...props} = this.props;
		const {data} = this.state;
		if (!open) {
			return null;
		}
		const disabled = !onSave;
		const loading = isSaving(data.service_id, data.kfz_id);
		return (
			<Form onSubmit={this.onSave} loading={loading} {...props}>
				{title && <PageHeader style={{marginBottom: 25}}>
					<Title as={'h4'}>
						{title}
					</Title>
				</PageHeader>}
				{!readOnlyTime &&
					<FormField required>
						<label>Arbeitszeit in Stunden (kleinste Einheit ist 0,1 Stunden, gerundet)</label>
						<Input
							labelPosition={'left'}
							icon
							type={'number'}
							min={0}
							step={0.1}
							required={!readOnlyTime}
							readOnly={readOnlyTime}
							disabled={disabled}
							value={readOnlyTime ? 1 : data.hours_of_work}
							onChange={(_, data) => this.setData('hours_of_work', data.value)}
						>
							<FormLabel><TimeIcon/></FormLabel>
							<input readOnly={disabled}/>
						</Input>
					</FormField>
				}
				<FormField required={priceRequired}>
					<label>Preis pro Stunde</label>
					<Input
						labelPosition={'left'}
						icon
						type={'number'}
						min={0}
						disabled={disabled}
						required={priceRequired}
						value={data.price}
						step={0.01}
						onChange={(_, data) => this.setData('price', data.value)}
					>
						<FormLabel><EuroIcon/></FormLabel>
						<input readOnly={disabled}/>
					</Input>
				</FormField>
				<Subbar align={Subbar.ALIGN_BETWEEN} style={{marginTop: 20}}>
					{!this.isNew() && onDelete ? <Button type={'button'} negative onClick={() => onDelete(data.service_id, data.kfz_id)}>{t('actions.delete')}</Button> : <span/>}
					{onSave ? <Button type={'submit'} positive>{t('actions.save')}</Button> : <span/>}
					{onShowDetail ? <Button type={'button'} color={'blue'} onClick={() => onShowDetail(data.service_id, data.kfz_id)}>Details</Button> : <span/>}
				</Subbar>
			</Form>
		);
	}
}

export const PriceInfo = ({price, time}) => (
	<Subbar valign={Subbar.VALIGN_CENTER}>
		<TimeIcon style={{width: 18, height: 18}}/> {time} <EuroIcon style={{width: 15, height: 15, marginLeft: 10}}/> {isNum(price) ? price : '-'}
	</Subbar>
);
PriceInfo.propTypes = {
	price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	time: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default translate()(WorkTime);


// WEBPACK FOOTER //
// ./src/components/WorkTime.js